var map = {
	"./05.svg": 1082,
	"./07.svg": 1410,
	"./09.svg": 8836,
	"./12.svg": 1490,
	"./14.svg": 1988,
	"./18.svg": 8709,
	"./21.svg": 1622,
	"./23.svg": 6271,
	"./26.svg": 692,
	"./32.svg": 3861,
	"./35.svg": 2083,
	"./43.svg": 8895,
	"./46.svg": 591,
	"./48.svg": 6207,
	"./51.svg": 202,
	"./53.svg": 8197,
	"./56.svg": 178,
	"./59.svg": 9075,
	"./61.svg": 2346,
	"./63.svg": 607,
	"./65.svg": 4005,
	"./68.svg": 8053,
	"./71.svg": 9524,
	"./74.svg": 6444,
	"./77.svg": 5375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9309;